

import UIComponent from "../ui/component";
import api from "../api";
import FilesApi from "../api/files";
import { getCorrectWord, getPriceWithSymbol } from "../utils/prulization.js";
import goals from "../utils/goals.js";

export class Subscriptions extends UIComponent {
    init() {
        if (!Number(this.available_region)) {
            this.includeComponents({
                regionPaymentModal:
                    'document@#regionPaymentModal',
            });
        }

        this.priceSwitch = this.find("#pricing");
        this.subscriptionType = "monthly";
        this.pricing_switch?.on("change", (e) => this.handleSubscriptionChange(e));

        this.subsBtn?.on("click", this.handleSubscribe.bind(this));
        this.subsBtnSurcharge?.on("click", this.handleSurchargeSubscribe.bind(this));

        this.responseData = null;
        this.loadInitialSubscription();
    }

    async loadInitialSubscription() {
        try {
            const response = await api.get(this.sub_url);
            if (response) {
                this.responseData = response;

                if (response.available === "yearly") {
                    this.subscriptionType = "yearly";
                } else {
                    this.subscriptionType = "monthly";
                }

                this.updatePrices(response.subscription, this.subscriptionType);
                this.updatePeriod(this.subscriptionType);
            }
        } catch (error) {
            console.error("Failed to load initial subscription:", error);
            this.errorBag?.show("Failed to load subscription options on page load");
        }
    }

    async handleSurchargeSubscribe(e) {
        e.preventDefault();
        goals.reach('subscription_selected');

        try {
            const fileId = window.location.pathname.split("/").pop();
            if (!fileId || isNaN(fileId)) {
                throw new Error("Invalid file ID");
            }

            const paymentData = {
                files: [fileId],
                addToQueue: 1,
                options: { language: "auto" },
                offer: this.offer,
                variant: this.subscriptionType
            }

            if (!Number(this.available_region)) {
                this.regionPaymentModal?.show(paymentData, true);
                return;
            }

            const response = await FilesApi.transcribe(paymentData);

            if (response?.offers?.[offer].redirect_url) {
                const redirectUrl = new URL(response?.offers?.[offer].redirect_url);
                redirectUrl.searchParams.set('return', window.location.pathname);
                window.location.href = redirectUrl.toString();
            } else {
                throw new Error("No redirect URL in response");
            }
        } catch (error) {
            console.error("Surcharge subscription error:", error);
            this.errorBag?.show(error.message || "Failed to process subscription");
        }
    }

    async handleSubscriptionChange(e) {
        const isAnnual = e.target.checked;
        this.subscriptionType = isAnnual ? "yearly" : "monthly";
        try {
            const url = isAnnual ? this.sub_url + "?type=yearly" : this.sub_url;
            const response = await api.get(url);
            if (response) {
                this.responseData = response;
                this.updatePrices(response.subscription, this.subscriptionType);
                this.updatePeriod(this.subscriptionType);
            }
        } catch (error) {
            console.error("Failed to load subscription data:", error);
            this.errorBag?.show("Failed to load subscription options");
        }
    }

    updatePrices(priceData, subscriptionType) {
        this.minute_cost.element.textContent = priceData?.formatted_minute_cost;
        let price = this.find("#price");
        if (price) {
            price.textContent = priceData?.amount_formatted;
        }

        let url = subscriptionType === "monthly" ? `&prolongation=yearly` : `&prolongation=monthly`;

        [this.subsBtn, this.subsBtnSurcharge].forEach(btn => {
            if (btn?.sub_url?.includes(url)) {
                btn.sub_url = btn.sub_url.replace(url, "");
            }
            if (btn?.sub_url) {
                btn.sub_url += `&prolongation=${subscriptionType}`;
            }
        });
    }

    updatePeriod(subscriptionType) {
        if (this.responseData?.available === "yearly") {
            this?.period?.hide();
            this?.pricing_switch?.hide();
        } else {
            this?.period?.show();
            this?.pricing_switch?.show();
        }

        let type = subscriptionType === "monthly" ? this?.period?.type_month : this?.period?.type_year;
        if (this.period?.element) {
            this.period.element.textContent = type;
        }
    }

    handleSubscribe() {
        if (this.responseData?.available === "yearly") {
            this.subscriptionType = "yearly";
        }

        const subUrl = new URL(decodeURIComponent(this.subsBtn.sub_url));
        subUrl.searchParams.set('prolongation', this.subscriptionType);
        subUrl.searchParams.set('return', this.subsBtn.return_url);

        window.location.href = subUrl.toString();
    }
}
